import { reactive, ref } from "vue";
import { ENDPOINTS, openIdLoginError, skapi } from "@/main";
// import { ServiceSpec } from "@/views/service/service-spec";
import {
    allServicesLoaded,
    fetchingServiceList,
    serviceList,
    serviceIdList,
    serviceSpecList,
    loadServiceList,
    serviceRaw,
} from "@/views/service-list";
import { initialLoadDone } from "@/views/service/main";
import { track } from "@/assets/js/event";

// 추가: 모든 서비스가 로드 완료되었는지 추적하기 위한 상태
// export const allServicesLoaded = vueRef(false);
let pendingLoads = 0; // 현재 로딩 중인 Service.load 호출 수
import { miscUpdater } from "@/code/misc";
import Service, { type PublicUser } from "./service";

export let user: { [key: string]: any } = reactive({});

export let customer: Promise<Customer> = null;
export let emailSubscribed = ref(null);

type Customer = {
    id: string;
    object: "customer";
    address: {
        city: string;
        country: string;
        line1: string;
        line2: string;
        postal_code: string;
        state: string;
    };
    balance: number;
    created: number;
    currency: string;
    default_source: any;
    delinquent: boolean;
    description: any;
    discount: any;
    email: string;
    invoice_prefix: string;
    invoice_settings: {
        custom_fields: any;
        default_payment_method: any;
        footer: any;
        rendering_options: any;
    };
    livemode: boolean;
    metadata: {
        [key: string]: any;
    };
    name: string;
    next_invoice_sequence: number;
    phone: any;
    preferred_locales: any[];
    shipping: any;
    tax_exempt: string;
    test_clock: any;
};

let previousUserId = "";

export let initUser = (userIncoming) => {
    for (let k in user) {
        delete user[k];
    }
    if (userIncoming) {
        for (let k in userIncoming) {
            user[k] = userIncoming[k];
        }
    }
};

export let userLoginCallback = async (userIncoming: any) => {
    if (userIncoming) {
        let userIncomingMisc = JSON.parse(userIncoming.misc || "{}");
        let getServices = null;

        // misc.changePassword 아직 필요한 정보인지 체크 필요
        if (userIncomingMisc?.changePassword) {
            if (userIncomingMisc.changePassword === true) {
                getServices = true;
            } else {
                getServices = false;
            }
        }

        previousUserId = userIncoming.user_id;
        getStripeCustomer(userIncoming);

        // get newsletter subscription status
        if (emailSubscribed.value === null) {
            skapi
                .getNewsletterSubscription({
                    group: "authorized",
                })
                .then((subs) => {
                    emailSubscribed.value = !!subs.length;
                });
        }

        // auto subscribe google users to newsletter
        if (
            userIncoming?.signup_ticket &&
            userIncoming?.signup_ticket === "OIDPASS" &&
            !emailSubscribed.value &&
            !userIncomingMisc.googleUserSubscribed
        ) {
            await skapi.subscribeNewsletter({
                group: "authorized",
            });
            userIncomingMisc.googleUserSubscribed = true;
            miscUpdater.update({ googleUserSubscribed: true });
            emailSubscribed.value = true;
        }

        // get service list
        while (serviceIdList.length > 0) {
            serviceIdList.pop();
        }
        for (let k in serviceList) {
            delete serviceList[k];
        }
        for (let k in serviceSpecList) {
            delete serviceSpecList[k];
        }

        fetchingServiceList.value = true;
        allServicesLoaded.value = false;
        initialLoadDone.value = false;

        let {
            admin_private_endpoint,
            admin_public_endpoint,
            record_private_endpoint,
        } = await ENDPOINTS;

        skapi.util
            .request(
                admin_private_endpoint + "get-services",
                {
                    service: skapi.service,
                    owner: skapi.owner,
                    bypass_cached_service: true,
                },
                { auth: true },
            )
            .then(async (srvcs) => {
                // fetchingServiceList.value = false;
                // allServicesLoaded.value = true;

                for (let region in srvcs) {
                    if (!Array.isArray(srvcs[region])) continue;

                    for (let svc of srvcs[region]) {
                        serviceIdList.push(svc.service);
                        serviceRaw[svc.service] = svc;
                    }
                }

                // order the serviceIdList to big to small from serviceRaw[serviceId].timestamp
                serviceIdList.sort((a, b) => {
                    return (
                        (serviceRaw[b].timestamp || 0) -
                        (serviceRaw[a].timestamp || 0)
                    );
                });

                fetchingServiceList.value = false;

                // 라우터 이동이 완료될 때까지 대기
                const router = (await import("@/router")).default;
                await router.isReady();
                loadServiceList();

                // allServicesLoaded.value = true;
            });

        // skapi
        //     .getUsers({
        //         searchFor: "user_id",
        //         value: userIncoming.user_id,
        //     })
        //     .then(async (uInfo) => {
        //         let fetchedList = (uInfo.list[0] as PublicUser)?.services;
        //         if (Array.isArray(fetchedList)) {
        //             console.log({fetchedList})

        //             for (let k of fetchedList.reverse()) {
        //                 // reverse to show the latest service first
        //                 serviceIdList.push(k);
        //             }

        //             loadServiceList();
        //         }
        //         fetchingServiceList.value = false;
        //         allServicesLoaded.value = true;
        //     });

        userIncomingMisc.changePassword = false;

        // skapi.updateProfile({ misc: JSON.stringify(userIncomingMisc) });

        miscUpdater.update({ changePassword: false });
    } else {
        skapi.util.terminatePendingRequests();

        emailSubscribed.value === null;

        while (serviceIdList.length > 0) {
            serviceIdList.pop();
        }
        for (let k in serviceList) {
            delete serviceList[k];
        }
        for (let k in serviceSpecList) {
            delete serviceSpecList[k];
        }
        fetchingServiceList.value = false;
        allServicesLoaded.value = true;
    }
};

let getStripeCustomer = async (user: any) => {
    let misc;

    if (user?.misc && typeof user.misc === "string") {
        misc = JSON.parse(user.misc);
    } else {
        misc = {};
    }

    if (misc?.stripe_customer_id) {
        // stripe_customer_id exists

        let customer_id = misc.stripe_customer_id;

        // get customer info, and update customer.value
        customer = skapi.clientSecretRequest({
            clientSecretName: "stripe_test",
            url: `https://api.stripe.com/v1/customers/${customer_id}`,
            method: "GET",
            headers: {
                Authorization: "Bearer $CLIENT_SECRET",
            },
        });

        // console.log("Existing stripe customer id:", customer_id);
        // console.log("Customer info:", await customer);
    } else {
        // stripe_customer_id does not exist

        // create customer, save customer id in user misc
        customer = skapi.clientSecretRequest({
            clientSecretName: "stripe_test",
            url: "https://api.stripe.com/v1/customers",
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer $CLIENT_SECRET",
            },
            data: {
                name: user.name || user.email,
                email: user.email,
            },
        });

        // console.log("Created new stripe customer:", await customer);

        // update customer id in user misc
        customer.then(async (c) => {
            if (c) {
                misc.stripe_customer_id = c.id;
                miscUpdater.update({
                    stripe_customer_id: misc.stripe_customer_id,
                });
            }
        });
    }
};

// 구독 페이지 등에서 전체 서비스 로딩 완료를 기다릴 때 사용하는 헬퍼
// export const waitAllServices = (timeoutMs = 7000): Promise<boolean> => {
//     return new Promise((resolve) => {
//         if (allServicesLoaded.value) {
//             return resolve(true);
//         }
//         const start = Date.now();
//         const interval = setInterval(() => {
//             if (allServicesLoaded.value) {
//                 clearInterval(interval);
//                 resolve(true);
//             } else if (Date.now() - start > timeoutMs) {
//                 clearInterval(interval);
//                 resolve(false); // 타임아웃
//             }
//         }, 120);
//     });
// };

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID; // Replace this with your actual client ID

export function googleLogin(e: Event, trackTarget: string) {
    e.preventDefault();
    openIdLoginError.value = null;

    const REDIRECT_URL = window.location.href.split("?")[0]; // Current URL to redirect back from Google login page
    let rnd = Math.random().toString(36).substring(2); // Generate a random string

    // Build link to login page
    let url = "https://accounts.google.com/o/oauth2/v2/auth";
    url += "?client_id=" + GOOGLE_CLIENT_ID;
    url += "&redirect_uri=" + encodeURIComponent(REDIRECT_URL);
    url += "&response_type=code";
    url +=
        "&scope=" +
        encodeURIComponent(
            "https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email",
        );
    url += "&prompt=consent";
    url += "&state=" + encodeURIComponent(rnd);
    url += "&access_type=offline";

    // Redirect user to the URL
    // window.location.href = url;

    track(
        {
            user_id: user?.user_id || "guest",
            target: trackTarget,
        },
        () => {
            window.location.href = url;
        },
    );
}
